module.exports = __webpack_public_path__ + "static/media/blue-loader.1ae4b889.svg";